import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { HttpInterceptor } from '../shared/index';
import { CONSTANT_VALUES } from '../constants/constant-values';
import { environment } from '../../environments/environment';

@Injectable()
export class AccountService {
	constructor(private http: HttpInterceptor) {
	}

	getPaymentHistory(reqObject) {
		let url = CONSTANT_VALUES.URL_PAYMENT_HISTORY;
		return new Promise((resolve, reject) => {
			this.http.post(url, reqObject).map((res) => res.json()).subscribe(data => {
				resolve(data);
			});
		});
	}

	generateInvoice(reqObject) {
		let url = CONSTANT_VALUES.URL_GENERATE_PENALTY_INVOICE;
		return new Promise((resolve, reject) => {
			this.http.post(url, reqObject).map((res) => res.json()).subscribe(data => {
				resolve(data);
			});
		});
	}


	sendInvoice(reqObject) {
		let url = CONSTANT_VALUES.URL_SEND_INVOICE;
		return new Promise((resolve, reject) => {
			this.http.post(url, reqObject).map((res) => res.json()).subscribe(data => {
				resolve(data);
			});
		});
	}

	getPendingInvoice(reqObject) {
		let url = CONSTANT_VALUES.URL_GET_PENDING_INVOICES;
		return new Promise((resolve, reject) => {
			this.http.post(url, reqObject).map((res) => res.json()).subscribe(data => {
				resolve(data);
			});
		});
	}

	manualInvoicePayment(reqObject) {
		let url = CONSTANT_VALUES.URL_PENALTY_PAYMENT;
		return new Promise((resolve, reject) => {
			this.http.post(url, reqObject).map((res) => res.json()).subscribe(data => {
				resolve(data);
			});
		});
	}

}


// WEBPACK FOOTER //
// ./src/app/account/account.service.ts